import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from "vue3-apexcharts";
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Import Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { library } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'maz-ui/styles'

library.add(fas, fab);

// استيراد الأيقونات المطلوبة
import { fas } from '@fortawesome/free-solid-svg-icons'; // أيقونات Solid
import { fab } from '@fortawesome/free-brands-svg-icons'; // أيقونات العلامات التجارية
import GlobalAlert from './components/alert.vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'



const app = createApp(App);
app.use(ElementPlus)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.component('GlobalAlert', GlobalAlert).component('font-awesome-icon', FontAwesomeIcon).use(store).use(router).use(VueApexCharts).mount('#app')


